// Opens a page in the user's default browser. The second file allowed to touch `Office.context.ui` (with
// `dialog.ts`; the documented exception to "Office.js only in ExcelToolExecutor" — it never touches the workbook).
// `openBrowserWindow` (OpenBrowserWindowApi 1.1) leaves the task pane's webview for the real browser, where the
// portal's own session lives; `window.open` is the fallback where the API is missing.

export function openInBrowser(url: string): void {
  const ui = typeof Office !== 'undefined' ? Office.context?.ui : undefined;
  if (ui && typeof ui.openBrowserWindow === 'function') {
    try {
      ui.openBrowserWindow(url);
      return;
    } catch (err) {
      console.warn('[agent-v2] openBrowserWindow failed, falling back to window.open', err);
    }
  }
  window.open(url, '_blank', 'noopener');
}
